/* TypeScript file generated from StatsView.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// tslint:disable-next-line:no-var-requires
const StatsViewBS = require('./StatsView.bs');

import {style as ReactDOMRe_style} from '../../src/shims/ReactDOMRe.shim';

// tslint:disable-next-line:interface-over-type-literal
export type Props = {
  readonly className?: string; 
  readonly interestedSpaceContactCount?: number; 
  readonly notInterestedSpaceContactCount?: number; 
  readonly spaceContactCount?: number; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
};

export const $$default: React.ComponentType<{
  readonly className?: string; 
  readonly interestedSpaceContactCount?: number; 
  readonly notInterestedSpaceContactCount?: number; 
  readonly spaceContactCount?: number; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
}> = StatsViewBS.default;

export default $$default;
